import * as commonStyles from "styles/Common.module.scss";

import CustomLoader from "components/common/CustomLoader/CustomLoader";
import MongoliaDataForm from "./MongoliaDataForm";
import NoDataFound from "components/common/NoDataFound/NoDataFound";
import { getErrorMessage } from "common/utils/errorUtils";
import { getMongoliaDataDetail } from "common/API/mongolianProgramAPIs";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";

import { PAGE_IDENTIFIERS } from "common/constants";
import { clearMongoliaFilters } from "common/utils/utils";
import { useAutoClearFilter } from "common/hooks/useAutoClearFitlers";

const MongoliaDataDetail = () => {
  const { recordId } = useParams();

  /* To automatically clear mongolian-program filters for a given page identifier. */
  const pageIdentifier = PAGE_IDENTIFIERS.MONGOlIAN_PROGRAM;
  useAutoClearFilter(pageIdentifier, clearMongoliaFilters);

  const {
    data: response,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery(["mongolia-data-detail", recordId], () =>
    getMongoliaDataDetail(recordId)
  );

  if (isLoading) {
    return (
      <CustomLoader
        containerClasses={commonStyles.Full_Height_Flex_Container}
      />
    );
  }

  if (error?.response?.status === 404) {
    return (
      <NoDataFound
        {...{
          title: `No mongolia record with ID ${recordId} found`,
          wrapperClasses: commonStyles.Full_Height_Flex_Container,
        }}
      />
    );
  }

  if (isError) {
    toast.error(
      getErrorMessage(
        error,
        `Cannot fetch requested record with ID ${recordId}`
      )
    );
  }

  return (
    <main className="px-1 py-5">
      <MongoliaDataForm
        {...{ record: response?.data?.payload, refetchRecord: refetch }}
      />
    </main>
  );
};

export default MongoliaDataDetail;
